import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { AgentLifeTime } from '../../../../../components/BottomAuthorBlockNew/parts/AgentInfo/parts/AgentLifeTime';
import { selectOfferAgent } from '../../../../../selectors';
import { getLifeTime } from '../../../../../utils/agent';

export const AgentLifeTimeContainer: React.FC = () => {
  const agent = useSelector(selectOfferAgent, shallowEqual);
  const lifeTime = agent && getLifeTime(agent);

  if (!lifeTime) {
    return null;
  }

  return (
    <li>
      <AgentLifeTime lifeTime={lifeTime} />
    </li>
  );
};
